import graphqlClient from '../../api/axios_interceptor';

import {
    ADD_MAINTENANCE,
    DELETE_MAINTENANCE,
    FETCH_MAINTENANCES, 
    UPDATE_MAINTENANCE
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

import { AddMaintenancesMutation, FetchMaintenancesQuery, DeleteMaintenanceMutation, UpdateMaintenancesMutation } from '../../api/graphql/queries/maintenance';
import { getFormData } from './functions';
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';


export const parseMaintenance = (maintenance) => ({
    maintenanceId: maintenance.id,
    unitId: maintenance.unit ? maintenance.unit.id : "",
    propertyId: maintenance.property.id,
    status: maintenance.status,
    category: maintenance.category,
    description: maintenance.description,
    shortSummary: maintenance.shortSummary,
    fileName: maintenance.upload? maintenance.upload.file : "",
    fileId: maintenance.upload? maintenance.upload.id : "",
    createdTs: new Date(maintenance.createdTs),
    isCreatedByLandlord: maintenance.isCreatedByLandlord,
    expenseId: maintenance.expense ? maintenance.expense.id : "",
});

export const fetchMaintenancesMiddleware =  async (action) => {
    try{
        let payload = action.payload;
        let maintenances = {};
        const query = FetchMaintenancesQuery(payload.propertyIds, payload.unitIds, payload.maintenanceIds, payload.status, payload.category, payload.offset);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            maintenances = queryResult.data.data.propertyMaintenances.maintenances.map(parseMaintenance);
            action = ({
                ...action,
                payload: {
                    ...action.payload,
                    maintenances
                },
                offset: queryResult.data.data.propertyMaintenances.next,
                summary: queryResult.data.data.propertyMaintenances.summary
            });
        }); 

    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


const addMaintenanceMiddleware = async (action) => {
    let payload = action.payload;
    try{
        let query = AddMaintenancesMutation(payload.propertyId, payload.unitId,
            payload.status, payload.category, payload.shortSummary, payload.description,
            payload.createExpense, payload.expenseAmount);
        const formData = getFormData(query, action.payload.fileUpload);

        await FormDataRestClient.post(
            GRAPHQL_API, formData
            ).then((queryResult) => {
            if (queryResult.data.errors ){
                action = updateActionErrors(action, queryResult.data.errors);

            }else if(queryResult.data.data.addMaintenance.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.addMaintenance.errorMessage);
            }
            else{
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        maintenance: parseMaintenance(queryResult.data.data.addMaintenance.maintenance)
                    }
                });
            }
        })
    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;    
}

const updateMaintenanceMiddleware = async (action) => {
    try{
        let payload = action.payload;
        //let maintenance = payload;
        let query = UpdateMaintenancesMutation(payload.maintenanceId, payload.propertyId, payload.unitId,
            payload.status, payload.category, payload.shortSummary, payload.description, payload.updateFile);
            const formData = getFormData(query, action.payload.fileUpload);

        await FormDataRestClient.post(
            GRAPHQL_API, formData
            ).then((queryResult) => {
            if (queryResult.data.errors ){
                action = updateActionErrors(action, queryResult.data.errors);

            }else if(queryResult.data.data.updateMaintenance.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.updateMaintenance.errorMessage);
            }
            else{
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        maintenance: parseMaintenance(queryResult.data.data.updateMaintenance.maintenance)
                    }
                });
            }
        })
    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;    
}

const deleteMaintenanceMiddleware = async action => {
    try{
        let payload = action.payload;
        await graphqlClient({
            data: {
                query: DeleteMaintenanceMutation(payload.maintenanceId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors);
            }else if(queryResult.data.data.deleteMaintenance.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.deleteMaintenance.errorMessage);
            }
            else{
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        success: queryResult.data.data.deleteMaintenance.success
                    }
                });
            }
        })
    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const maintenancesMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case FETCH_MAINTENANCES:
            action = await fetchMaintenancesMiddleware(action);
            break;
        case ADD_MAINTENANCE:
            action = await addMaintenanceMiddleware(action);
            break;
        case UPDATE_MAINTENANCE:
            action = await updateMaintenanceMiddleware(action);
            break;
        case DELETE_MAINTENANCE:
            action = await deleteMaintenanceMiddleware(action);
    }
    return next(action);
}
